import { Component } from 'react'
import PropTypes from 'prop-types'

import rollbar from '@cred/shared/rollbar'

class ApplicationErrorBoundary extends Component {
  static getDerivedStateFromError(error) {
    return { error }
  }

  state = { error: undefined }

  componentDidCatch(error) {
    const { clientLibrary } = this.props
    rollbar.error('Credible Partners Widget: Unhandled error', error)
    clientLibrary.sendMessage('onError')
  }

  render() {
    const { error } = this.state
    const { children } = this.props

    if (error) {
      return null
    }

    return children
  }
}

ApplicationErrorBoundary.propTypes = {
  children: PropTypes.element.isRequired,
  clientLibrary: PropTypes.object.isRequired,
}

export default ApplicationErrorBoundary
